import { Link } from 'react-router';

import HorizontalScroll from '@cartwhl/ui/atoms/HorizontalScroll';
import LazyVideo from '@cartwhl/ui/atoms/LazyVideo';
import Text from '@cartwhl/ui/base/Text';

import ContentButton from 'components/ContentButton';
import SectionHeader from 'components/SectionHeader';
import { CDN } from 'consts';
import { useCarousel } from 'hooks/useCarousel';

import { VerticalNavButtons } from './VerticalNavButtons';

const caseStudies = [
  {
    company: 'Psyop',
    title:
      "Repairing broken mocap data using Cartwheel's interpolation technology",
    videoSrc: `${CDN}psyop_cover.webm`,
    url: '/blog/psyop',
  },
  {
    company: 'Dogstar',
    title: 'Episodic Content at Social Media Speed',
    videoSrc: `${CDN}v2_homepage_case_studies_01_dogstar.webm`,
    url: '/blog/dogstar',
  },
];

export default function CaseStudiesSection() {
  const {
    scrollRef,
    firstItemRef,
    intersectionRef,
    canScrollPrev,
    canScrollNext,
    scrollPrev,
    scrollNext,
  } = useCarousel();

  return (
    <section
      ref={intersectionRef}
      className="pb-(--vertical-spacing) pt-8 lg:pt-14"
    >
      <div className="container">
        <SectionHeader
          title="Case studies"
          description="See how teams across industries are modernizing motion pipelines with Cartwheel."
        />
      </div>

      {/* Carousel - extends beyond container */}
      <HorizontalScroll ref={scrollRef} as="section">
        {caseStudies.map((study, index) => (
          <div
            key={study.title}
            ref={index === 0 ? firstItemRef : undefined}
            className="flex w-[320px] shrink-0 snap-start flex-col gap-7 lg:w-[632px] lg:gap-10 xl:w-[848px]"
          >
            <Link
              to={study.url}
              className="hover:shadow-menu group relative h-[184px] overflow-hidden rounded-2xl transition-shadow lg:h-[352px] xl:h-[480px]"
            >
              <LazyVideo
                src={study.videoSrc}
                className="absolute inset-0 h-full w-full rounded-[inherit]"
                mode="autoplay"
              />
              <div className="absolute bottom-4 left-4 lg:bottom-6 lg:left-6">
                <ContentButton>Read More</ContentButton>
              </div>
            </Link>

            <div className="flex flex-col gap-5 lg:gap-7">
              <Text
                variant="web/body/medium/md"
                lg:variant="web/body/medium/24"
                className="text-tertiary"
              >
                {study.company}
              </Text>
              <Text
                variant="web/body/medium/lg"
                lg:variant="web/body/medium/xl"
              >
                {study.title}
              </Text>
            </div>
          </div>
        ))}
      </HorizontalScroll>

      {/* Navigation */}
      <VerticalNavButtons
        disablePrev={!canScrollPrev}
        disableNext={!canScrollNext}
        onPrev={scrollPrev}
        onNext={scrollNext}
        className="container mt-8"
      />
    </section>
  );
}
